function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'rozowy': 'rgb(213, 189, 229)','bezowy': 'rgb(243, 232, 216)','jasnoniebieski': 'rgb(211, 170, 170)','fioletowy': 'rgb(179, 159, 205)','bialy': 'rgb(255, 255, 255)','liliowy': 'rgb(220, 213, 217)','czerwony': 'rgb(255, 0, 0)','zielony': 'rgb(0, 128, 0)','niebieski': 'rgb(81, 123, 173)','czarny': 'rgb(0, 0, 0)','granatowy': 'rgb(0, 0, 139)','ciemnobrazowy': 'rgb(76, 42, 18)','jasnobrazowy': 'rgb(180, 125, 73)','zolty': 'rgb(255, 255, 0)','morski-granatowy': 'rgb(0, 0, 139)','czerwono-czarny': 'rgb(255, 0, 0)','czarno-czerwony': 'rgb(0, 0, 0)','czarno-bialy': 'rgb(255, 255, 255)','czarno-zloty': 'rgb(255, 215, 0)','jasnozielony': 'rgb(152, 251, 152)','oliwkowy': 'rgb(128, 128, 0)','zolty': 'rgb(252, 252, 64)','niebiesko-czarny': 'rgb(81, 123, 173)','szaro-czarny': 'rgb(128, 128, 128)','bialo-czarny': 'rgb(255, 255, 255)','bezowy': 'rgb(245, 245, 220)','szary': 'rgb(128, 128, 128)','pomaranczowy': 'rgb(255, 165, 0)','bordowy': 'rgb(128, 0, 0)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor','kolor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
